import type { BlokProps } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import BlokWrap from "@/components/bloks/BlokWrap";
import { RichTextRenderer } from "@/components/ui/RichText";
import type { BlokStoryCard } from "@/storyblok";
import { AssetBlok, multiAssetToSingleAsset, sizes } from "../Asset";
import styles from "./StoryCard.module.css";

export const StoryCardBlok = ({
	blok,
	preview,
	...rest
}: BlokProps<BlokStoryCard>) => {
	const reverse = blok.reverse || false;
	return (
		<BlokWrap
			editable={blok}
			as="div"
			data-zero-space
			{...rest}
			className={clsx(styles.root, reverse && styles.reverse)}
		>
			<div className={styles.mediaWrapper}>
				<div className={styles.media}>
					<AssetBlok
						source={multiAssetToSingleAsset(blok.media!)}
						muted
						autoPlay
						loop
						priority
						quality={90}
						sizes={sizes(90, 80)}
					/>
				</div>
			</div>
			<div className={styles.text}>
				{blok.title && <h2 className={styles.title}>{blok.title}</h2>}

				{blok.description && (
					<div className={styles.description}>
						<RichTextRenderer blok={blok.description} preview={preview} />
					</div>
				)}
			</div>
		</BlokWrap>
	);
};
